import { createAsyncThunk } from "@reduxjs/toolkit";
import type { SystemFieldsRequest, SystemFieldsResponse } from "../../models/systemFields";
import { environment } from "../../environments";

const API_BASE_URL = environment.apiUrl;

/** שליפת שדות מערכת לפי סוג אירוע */
export const getSystemFields = createAsyncThunk<
  SystemFieldsResponse,
  SystemFieldsRequest,
  { rejectValue: string }
>(
  "systemFields/GetSystemFields",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}SystemFields/GetSystemFields`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestData),
        },
      );

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data: SystemFieldsResponse = await response.json();

      if (!data.success)
        return rejectWithValue(data.message || "Failed to fetch system fields");
      return data;
    } catch (error) {
      return rejectWithValue(
        error instanceof Error ? error.message : "Unknown error",
      );
    }
  },
);
